import { useMemo } from "react";

export function useMetaKey(): string {
  const metaKey = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMac = userAgent.includes("mac") || userAgent.includes("darwin");
    return isMac ? "⌘" : "Ctrl";
  }, []);

  return metaKey;
}
